(function () {
  var SLIDE_DURATION = 400;

  function measureOpen(panel) {
    var display = panel.style.display;
    var height = panel.style.height;
    var paddingTop = panel.style.paddingTop;
    var paddingBottom = panel.style.paddingBottom;

    panel.style.display = 'block';
    panel.style.height = 'auto';
    panel.style.paddingTop = '';
    panel.style.paddingBottom = '';

    var computed = window.getComputedStyle(panel);
    var open = {
      height: panel.getBoundingClientRect().height,
      paddingTop: parseFloat(computed.paddingTop) || 0,
      paddingBottom: parseFloat(computed.paddingBottom) || 0
    };

    panel.style.display = display;
    panel.style.height = height;
    panel.style.paddingTop = paddingTop;
    panel.style.paddingBottom = paddingBottom;

    return open;
  }

  function slideToggle(panel, opening) {
    if (panel._slideFrame) cancelAnimationFrame(panel._slideFrame);

    var computed = window.getComputedStyle(panel);
    var hidden = computed.display === 'none';
    var open = measureOpen(panel);
    var startHeight = hidden ? 0 : panel.getBoundingClientRect().height;
    var startPaddingTop = hidden ? 0 : (parseFloat(computed.paddingTop) || 0);
    var startPaddingBottom = hidden ? 0 : (parseFloat(computed.paddingBottom) || 0);
    var endHeight = opening ? open.height : 0;
    var endPaddingTop = opening ? open.paddingTop : 0;
    var endPaddingBottom = opening ? open.paddingBottom : 0;
    var startTime = performance.now();

    panel.style.display = 'block';
    panel.style.overflow = 'hidden';
    panel.style.height = startHeight + 'px';
    panel.style.paddingTop = startPaddingTop + 'px';
    panel.style.paddingBottom = startPaddingBottom + 'px';

    function swing(progress) {
      return 0.5 - Math.cos(progress * Math.PI) / 2;
    }

    function step(now) {
      var progress = Math.min((now - startTime) / SLIDE_DURATION, 1);
      var eased = swing(progress);

      panel.style.height = (startHeight + (endHeight - startHeight) * eased) + 'px';
      panel.style.paddingTop = (startPaddingTop + (endPaddingTop - startPaddingTop) * eased) + 'px';
      panel.style.paddingBottom = (startPaddingBottom + (endPaddingBottom - startPaddingBottom) * eased) + 'px';

      if (progress < 1) {
        panel._slideFrame = requestAnimationFrame(step);
        return;
      }

      panel._slideFrame = null;
      panel.style.height = '';
      panel.style.paddingTop = '';
      panel.style.paddingBottom = '';
      panel.style.overflow = '';
      panel.style.display = opening ? 'block' : '';
    }

    panel._slideFrame = requestAnimationFrame(step);
  }

  function initFamilyClubMobileTable() {
    document.querySelectorAll('.family_club_mobile_table_button').forEach(function (button) {
      button.addEventListener('click', function () {
        button.classList.toggle('active');
        var panel = button.nextElementSibling;
        if (!panel) return;
        slideToggle(panel, button.classList.contains('active'));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFamilyClubMobileTable);
  } else {
    initFamilyClubMobileTable();
  }
})();

// ANNOUNCEMENT BAR STACK
(function () {
  function watchAnnouncementBars() {
    if (!window.syncAnnouncementBars) return;
    window.syncAnnouncementBars();

    if (!("ResizeObserver" in window) || window.syncAnnouncementBarsObserver) return;
    window.syncAnnouncementBarsObserver = new ResizeObserver(window.syncAnnouncementBars);
    document.querySelectorAll(".shopify-section--announcement-bar").forEach(function (bar) {
      window.syncAnnouncementBarsObserver.observe(bar);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchAnnouncementBars);
  } else {
    watchAnnouncementBars();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (window.syncAnnouncementBarsObserver && event.target.classList && event.target.classList.contains("shopify-section--announcement-bar")) {
      window.syncAnnouncementBarsObserver.observe(event.target);
    }
    if (window.syncAnnouncementBars) window.syncAnnouncementBars();
  });
})();

if (!window.customElements.get("image-text-blocks")) {
  class ImageTextBlocks extends HTMLElement {
    connectedCallback() {
      var items = this.querySelectorAll('[reveal-on-scroll="true"]');
      var motionQuery = window.themeVariables && window.themeVariables.mediaQueries && window.themeVariables.mediaQueries["motion-safe"];
      var motionSafe = motionQuery ? window.matchMedia(motionQuery).matches : false;

      if (!items.length || !motionSafe || !("IntersectionObserver" in window)) {
        items.forEach(function (item) {
          item.removeAttribute("reveal-on-scroll");
        });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          revealImageTextBlock(entry.target);
        });
      }, { rootMargin: "-200px 0px 0px 0px" });

      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  function revealImageTextBlock(item) {
    var image = item.querySelector("img");

    function start() {
      var animation = item.animate(
        [{ opacity: 0 }, { opacity: 1 }],
        { duration: 350, easing: "ease", fill: "forwards" }
      );

      animation.addEventListener("finish", function () {
        item.style.opacity = "1";
        item.removeAttribute("reveal-on-scroll");
      });
    }

    if (image && !image.complete) {
      image.addEventListener("load", start, { once: true });
      image.addEventListener("error", start, { once: true });
      return;
    }

    start();
  }

  window.customElements.define("image-text-blocks", ImageTextBlocks);
}

// PRODUCT GROUP
// Products connected through the "custom.product_group" metaobject are rendered as swatches inside the variant picker.
// Clicking one swaps the product page in place (soft navigation) instead of doing a full page load.
if (!window.customElements.get("product-group")) {
  class ProductGroup extends HTMLElement {
    static pageCache = new Map();
    static cacheTtl = 1000 * 60 * 5;
    static requestSerial = 0;
    static clientNavigated = false;
    static popstateBound = false;
    static swatchImageSelector = ".thumbnail-swatch > img";
    static swatchBackgroundSelector = ".color-swatch, .block-swatch__color";

    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.addEventListener("click", this.onClick, { signal });
      this.addEventListener("pointerenter", this.onPrefetch, { capture: true, signal });
      this.addEventListener("touchstart", this.onPrefetch, { capture: true, passive: true, signal });

      if (!ProductGroup.popstateBound) {
        ProductGroup.popstateBound = true;
        window.addEventListener("popstate", ProductGroup.onPopstate);
      }

      // Like the native variant picker, every connected product page is prefetched once the swatches are visible so
      // that switching is instant. Prefetches run with low priority and only when the browser is idle.
      if (this.isMainProduct && !(window.Shopify && window.Shopify.designMode)) {
        this.intersectionObserver = new IntersectionObserver(this.onIntersection);
        this.intersectionObserver.observe(this);
      }
    }

    disconnectedCallback() {
      this.abortController.abort();

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    onIntersection = (entries) => {
      if (!entries[0].isIntersecting) return;

      this.intersectionObserver.disconnect();

      const prefetchAll = () => {
        this.querySelectorAll('a[data-product-group-link]:not([aria-current="page"])').forEach((link) => {
          ProductGroup.fetchPage(link.href, { priority: "low" }).catch(() => {});
        });
      };

      if (window.requestIdleCallback) {
        window.requestIdleCallback(prefetchAll, { timeout: 2000 });
      } else {
        prefetchAll();
      }
    };

    get isMainProduct() {
      return this.getAttribute("context") === "main_product";
    }

    onClick = (event) => {
      const link = event.target.closest("a[data-product-group-link]");

      if (!link || !this.contains(link) || !this.isMainProduct) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (window.Shopify && window.Shopify.designMode) return;

      event.preventDefault();

      if (link.getAttribute("aria-current") === "page") return;

      ProductGroup.switchProduct(link.href, { pushState: true });
    };

    onPrefetch = (event) => {
      if (!this.isMainProduct || (window.Shopify && window.Shopify.designMode)) return;

      const link = event.target.closest ? event.target.closest("a[data-product-group-link]") : null;

      if (!link || link.getAttribute("aria-current") === "page") return;

      ProductGroup.fetchPage(link.href).catch(() => {});
    };

    static pageKey(href) {
      const url = new URL(href, window.location.origin);
      return url.pathname + url.search;
    }

    static handleFromPath(pathname) {
      const match = pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    }

    static currentHandle() {
      const element = document.querySelector('product-group[context="main_product"][product-handle]') || document.querySelector('variant-picker[context="main_product"][handle]');
      return element ? element.getAttribute("product-handle") || element.getAttribute("handle") : null;
    }

    static fetchPage(href, { priority = "auto" } = {}) {
      const key = ProductGroup.pageKey(href);
      const cached = ProductGroup.pageCache.get(key);

      if (cached && Date.now() - cached.timestamp < ProductGroup.cacheTtl) {
        return cached.promise;
      }

      const promise = fetch(href, { credentials: "same-origin", priority })
        .then((response) => {
          if (!response.ok) throw new Error("Product page request failed");
          return response.text();
        })
        .catch((error) => {
          ProductGroup.pageCache.delete(key);
          throw error;
        });

      ProductGroup.pageCache.set(key, { promise, timestamp: Date.now() });

      return promise;
    }

    static mainSections(main) {
      return Array.from(main.children).filter((child) => {
        return child.classList.contains("shopify-section") && !child.classList.contains("shopify-section-group-footer-group");
      });
    }

    // Replace the template sections of the current page with the ones of the fetched page. Scripts parsed by DOMParser
    // are never executed, so the page ends up exactly as a fresh load, minus inline section scripts.
    static replaceSections(doc) {
      const main = document.getElementById("main");
      const nextMain = doc.getElementById("main");

      if (!main || !nextMain) return false;

      const current = ProductGroup.mainSections(main);
      const incoming = ProductGroup.mainSections(nextMain);

      if (!incoming.length) return false;

      const anchor = current.length ? current[current.length - 1].nextSibling : main.firstChild;

      incoming.forEach((section) => {
        ProductGroup.neutralizeNoscript(section);
        document.adoptNode(section);
      });

      ProductGroup.keepUnchangedSwatchImages(current, incoming);

      current.forEach((section) => section.remove());
      incoming.forEach((section) => main.insertBefore(section, anchor));

      return true;
    }

    // DOMParser parses with scripting disabled, so <noscript> content becomes real elements. The variant picker's
    // fallback <select name="id"> would then join the product form and break the native variant picker, so the content
    // is turned back into inert text, exactly as the browser keeps it on a regular page load.
    static neutralizeNoscript(root) {
      const roots = [root, ...Array.from(root.querySelectorAll("template")).map((template) => template.content)];

      roots.forEach((scope) => {
        scope.querySelectorAll("noscript").forEach((noscript) => {
          noscript.textContent = noscript.innerHTML;
        });
      });
    }

    static syncHead(doc, selector, attribute) {
      const next = doc.querySelector(selector);
      const current = document.querySelector(selector);

      if (next && current) {
        current.setAttribute(attribute, next.getAttribute(attribute));
      }
    }

    // Mirrors the inline script of the main product section, which does not run on a soft navigation
    static rememberProduct() {
      const element = document.querySelector('product-group[context="main_product"][product-id]');
      const productId = element ? parseInt(element.getAttribute("product-id"), 10) : NaN;

      if (!productId) return;

      try {
        let items = JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]");
        items = items.filter((item) => item !== productId);
        items.unshift(productId);
        localStorage.setItem("theme:recently-viewed-products", JSON.stringify(items));
      } catch (error) {
        // Safari in private mode does not allow setting item, we silently fail
      }
    }

    static applyPage(html, href, { pushState }) {
      const doc = new DOMParser().parseFromString(html, "text/html");

      if (!ProductGroup.replaceSections(doc)) {
        window.location.assign(href);
        return;
      }

      if (doc.title) document.title = doc.title;

      ProductGroup.syncHead(doc, 'link[rel="canonical"]', "href");
      ProductGroup.syncHead(doc, 'meta[name="description"]', "content");
      ["og:title", "og:url", "og:image", "og:description"].forEach((property) => {
        ProductGroup.syncHead(doc, `meta[property="${property}"]`, "content");
      });

      if (pushState) {
        const nextLocation = new URL(href, window.location.origin);
        window.history.pushState({ productGroup: true }, "", nextLocation.pathname + nextLocation.search + nextLocation.hash);
      }

      ProductGroup.clientNavigated = true;
      ProductGroup.rememberProduct();

      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }

      const selected = document.querySelector('product-group[context="main_product"] a[data-product-group-link][aria-current="page"]');
      if (selected) selected.focus({ preventScroll: true });

      document.dispatchEvent(new CustomEvent("product-group:change"));
    }

    static switchProduct(href, { pushState }) {
      const serial = ++ProductGroup.requestSerial;

      document.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

      return ProductGroup.fetchPage(href)
        .then((html) => {
          if (serial !== ProductGroup.requestSerial) return;
          ProductGroup.applyPage(html, href, { pushState });
        })
        .catch(() => {
          if (serial === ProductGroup.requestSerial) window.location.assign(href);
        })
        .finally(() => {
          if (serial === ProductGroup.requestSerial) {
            document.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
          }
        });
    }

    static onPopstate() {
      if (!ProductGroup.clientNavigated) return;

      const nextHandle = ProductGroup.handleFromPath(window.location.pathname);

      if (!nextHandle || nextHandle === ProductGroup.currentHandle()) return;

      ProductGroup.switchProduct(window.location.href, { pushState: false });
    }

    // Swatch pictures usually stay the same across a variant or group change. Keep the loaded node when the URL
    // is unchanged. product:rerender is fired on the form and does not reach elements inside it, and the picker is
    // replaced by that event, so the listener stays on document for products that have no product group.
    static keepUnchangedSwatchImages(oldRoots, newRoots) {
      try {
        ProductGroup.reuseUnchangedSwatches(oldRoots, newRoots, ProductGroup.swatchImageSelector, ProductGroup.imageIdentity, (img) => img.complete && img.naturalWidth > 0);
        ProductGroup.reuseUnchangedSwatches(oldRoots, newRoots, ProductGroup.swatchBackgroundSelector, ProductGroup.backgroundIdentity, (element) => ProductGroup.backgroundIdentity(element) !== "", true);
      } catch (error) {}
    }

    static imageIdentity(img) {
      return (img.getAttribute("srcset") || img.getAttribute("src") || "").replace(/\s+/g, " ").trim();
    }

    static backgroundIdentity(element) {
      const match = (element.getAttribute("style") || "").match(/url\(\s*['"]?([^'")]+)['"]?\s*\)/);
      return match ? match[1] : "";
    }

    static reuseUnchangedSwatches(oldRoots, newRoots, selector, identity, reusable, copyState) {
      const pool = new Map();

      ProductGroup.swatchNodes(oldRoots, selector).forEach((node) => {
        if (reusable && !reusable(node)) return;
        const key = identity(node);
        if (!key) return;
        const bucket = pool.get(key) || [];
        bucket.push(node);
        pool.set(key, bucket);
      });

      ProductGroup.swatchNodes(newRoots, selector).forEach((incoming) => {
        const bucket = pool.get(identity(incoming));
        if (!bucket) return;

        const matchIndex = bucket.findIndex((node) => node !== incoming && node.tagName === incoming.tagName);
        if (matchIndex === -1) return;

        const live = bucket.splice(matchIndex, 1)[0];

        if (copyState) {
          ["class", "for", "href", "hidden", "data-tooltip"].forEach((name) => {
            if (!incoming.hasAttribute(name)) {
              live.removeAttribute(name);
              return;
            }
            if (live.getAttribute(name) !== incoming.getAttribute(name)) {
              live.setAttribute(name, incoming.getAttribute(name));
            }
          });
        }

        incoming.replaceWith(live);
      });
    }

    static swatchNodes(roots, selector) {
      const nodes = [];

      roots.forEach((root) => {
        if (!root || !root.querySelectorAll) return;
        root.querySelectorAll(selector).forEach((node) => nodes.push(node));
      });

      return nodes;
    }

    static onProductRerender(event) {
      const fragment = event.detail && event.detail.htmlFragment;
      const form = event.target;
      if (!fragment || !form || form.nodeName !== "FORM") return;

      const formId = form.getAttribute("id");
      if (!formId) return;

      try {
        document.querySelectorAll("product-rerender").forEach((rerender) => {
          if (rerender.getAttribute("observe-form") !== formId) return;

          const next = fragment.querySelector("#" + CSS.escape(rerender.id));
          if (!next) return;

          if (!rerender.hasAttribute("allow-partial-rerender") || event.detail.productChange) {
            ProductGroup.keepUnchangedSwatchImages([rerender], [next]);
            return;
          }

          rerender.querySelectorAll('[data-block-type="variant-picker"]').forEach((element) => {
            const blockId = element.getAttribute("data-block-id");
            if (!blockId) return;

            const matchingBlock = next.querySelector('[data-block-type="variant-picker"][data-block-id="' + CSS.escape(blockId) + '"]');
            if (!matchingBlock) return;

            ProductGroup.keepUnchangedSwatchImages([element], [matchingBlock]);
          });
        });
      } catch (error) {}
    }
  }

  document.addEventListener("product:rerender", ProductGroup.onProductRerender, true);
  window.customElements.define("product-group", ProductGroup);
}

// Sits in the main product form, after <buy-buttons>. Size changes replace <buy-buttons> and leave
// this element in place. Color changes replace the whole form, so the new element picks up the listeners.
if (!window.customElements.get("back-in-stock")) {
  class BackInStock extends HTMLElement {
    static bisView = null;
    static placing = false;
    static rerun = false;

    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const form = this.closest("form");

      form?.addEventListener("variant:change", (event) => {
        if (event.detail?.variant?.available) return;
        BackInStock.refire();
      }, { signal });

      document.addEventListener("product-group:change", () => {
        BackInStock.refire();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    // enable() ignores later calls, so grab the view it already created and run its product-page setup again.
    static getView() {
      if (BackInStock.bisView && typeof BackInStock.bisView.createProductPageTrigger === "function") return BackInStock.bisView;

      let router = null;
      const nativeApply = Function.prototype.apply;

      Function.prototype.apply = function (thisArg, args) {
        try {
          if (thisArg && thisArg._components && thisArg._components.backinstock) router = thisArg;
        } catch (error) {}

        return nativeApply.call(this, thisArg, args);
      };

      try {
        if (window.klaviyoBIS && typeof window.klaviyoBIS.enable === "function") {
          window.klaviyoBIS.enable("backinstock");
        }
      } finally {
        Function.prototype.apply = nativeApply;
      }

      BackInStock.bisView = router && router._components.backinstock;
      return BackInStock.bisView;
    }

    static mainSubmit() {
      const form = document.querySelector('form[id^="product-form-main-"]');
      return form && form.querySelector('button[type="submit"]');
    }

    // Klaviyo only knows the variant in the URL. A color with no matching size has none, so it can
    // mark an in-stock size as sold out and leave the notify link next to Add to cart.
    static sync() {
      const button = BackInStock.mainSubmit();
      const triggers = document.querySelectorAll('form[id^="product-form-main-"] .klaviyo-bis-trigger');

      if (!button || !button.disabled) {
        triggers.forEach((trigger) => trigger.remove());
        if (button) button.style.removeProperty("display");
        return;
      }

      button.style.setProperty("display", "none", "important");
      triggers.forEach((trigger, index) => {
        if (index === 0) trigger.style.setProperty("display", "flex", "important");
        else trigger.remove();
      });
    }

    static refire() {
      const button = BackInStock.mainSubmit();
      if (!button || !button.disabled) {
        BackInStock.sync();
        return;
      }

      const view = BackInStock.getView();
      if (!view) return;

      if (BackInStock.placing) {
        BackInStock.rerun = true;
        return;
      }

      BackInStock.placing = true;
      document.querySelectorAll(".klaviyo-bis-trigger").forEach((trigger) => trigger.remove());

      const getProductJSON = view.getProductJSON;
      let finished = false;
      const timeout = window.setTimeout(finish, 4000);

      view.createModal = function () {};
      view.getProductJSON = function (url, callback) {
        view.getProductJSON = getProductJSON;
        getProductJSON.call(view, url, function () {
          try {
            callback();
            BackInStock.sync();
          } finally {
            finish();
          }
        });
      };

      try {
        view.createProductPageTrigger();
      } catch (error) {
        view.getProductJSON = getProductJSON;
        finish();
      }

      function finish() {
        if (finished) return;
        finished = true;
        window.clearTimeout(timeout);
        BackInStock.placing = false;

        if (BackInStock.rerun) {
          BackInStock.rerun = false;
          BackInStock.refire();
        }
      }
    }
  }

  window.customElements.define("back-in-stock", BackInStock);
}
